<script>
  import ContainerBgImageHeadlineAndSubtitle from "$lib/components/container_bg_image_headline_and_subtitle.svelte";
  import "../../app.css";
  import { t } from "$lib/i18n.js";

  export let headline = "Default Headline";
  export let subheadline = "Default Subheadline";
  export let image;
  export let imageAlt = "Background";
  export let linkUrl = "";
  export let target = "_blank";
  export let textColor = "#FFFFFF";
  export let topheadline = "";
  export let backgroundColor = "";
</script>

<div class="container">
  <ContainerBgImageHeadlineAndSubtitle {headline} {subheadline} {image} {imageAlt} {linkUrl} {target} {textColor} {topheadline} {backgroundColor} />
  <div class="decoration">
    <p>{$t('routes.owner.ways_of_sharing.cols.2.label_accent')}</p>
  </div>
</div>

<style>
  .container {
    width: 100%;
    height: 550px;
    background: var(--surface-container);
    border-radius: 24px;
    overflow: hidden;
    position: relative;
    padding: 0px;
  }

  .decoration {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: 4px solid var(--orange);
    padding: 24px;
    border-radius: 24px;
    pointer-events: none;  /* ✅ Permette ai click di passare attraverso la decorazione */
  }

  .decoration p {
    color: var(--on-primary);
    padding-left: 16px;
    padding-right: 16px;
    padding-top: 4px;
    padding-bottom: 4px;
    background-color: var(--orange);
    border-radius: 24px;
    display: inline-block;
  }

  @media (max-width: 768px) {
    .container {
      height: 350px;
    }
  }
</style>
